import { FragmentSerializer as JSONSerializer } from 'ember-data-model-fragments/serializer';

export default class Address extends JSONSerializer {
  normalize(typeClass, hash) {
    // Merge empty strings into the payload, as Go's `omitempty` will omit them
    // (leading to ember-data assuming that they're unchanged).
    let defaults = {
      number: '',
      street: '',
      locality: '',
      district: '',
      region: '',
      postcode: '',
    };
    Object.assign(defaults, hash);
    hash = defaults;

    return super.normalize(typeClass, hash);
  }
}
